import classnames from 'classnames';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';
import Button from 'eventbrite_design_system/button/Button';

import { getTabItems } from '../utils';

import './tabNavigation.scss';

export const CTAButton = ({ CTA, CTAStyle, onClick }) => (
    <div className="eds-l-pad-bot-1 eds-show-up-sm tab-navigation__cta-button">
        <Button
            key={CTA.toString()}
            style={CTAStyle}
            onClick={onClick}
            disabled={!CTAStyle}
        >
            {CTA}
        </Button>
    </div>
);

export default class TabNavigation extends PureComponent {
    static propTypes = {
        currentIndex: PropTypes.number.isRequired,
        tabs: PropTypes.arrayOf(translationPropType).isRequired,
        tabActions: PropTypes.arrayOf(PropTypes.func).isRequired,
        tabPaths: PropTypes.arrayOf(PropTypes.string),
        CTA: translationPropType,
        onClick: PropTypes.func,
        isSmallType: PropTypes.bool,
    };

    _handleSelect(index) {
        const { tabActions } = this.props;

        return tabActions[index]();
    }

    render() {
        const {
            CTA,
            CTAStyle,
            currentIndex,
            tabs,
            tabPaths,
            onClick,
            alternateAlignment,
            isSmallType,
        } = this.props;
        const tabItems = getTabItems(
            currentIndex,
            tabs,
            this._handleSelect.bind(this),
            tabPaths,
            isSmallType,
        );
        let ctaButton = null;
        let alternateTabs = null;

        if (CTA) {
            ctaButton = (
                <CTAButton CTA={CTA} CTAStyle={CTAStyle} onClick={onClick} />
            );
        }

        if (alternateAlignment) {
            alternateTabs = (
                <div className="eds-show-up-sm eds-l-pad-hor-3">{tabItems}</div>
            );
        }

        const classsName = classnames('eds-align--center', {
            'eds-show-down-sn': alternateAlignment,
            'eds-show-down-mn': !alternateAlignment,
        });

        return (
            <div className="eds-align--center-vertical eds-l-pad-top-1 eds-text-color--grey-600">
                {alternateTabs}
                <div className={classsName}>{tabItems}</div>
                {ctaButton}
            </div>
        );
    }
}
